/** The three currencies the platform supports (mirrors the backend
 * ReportConfig Currency enum and the Backoffice project currencies). */
export const CURRENCY_SYMBOL: Record<string, string> = { GBP: '£', EUR: '€', USD: '$' };

export function currencySymbol(currency: string | null | undefined): string {
  return CURRENCY_SYMBOL[currency ?? ''] ?? '';
}

/** "£1,500" / "$950" — symbol + en-GB-grouped amount. Non-numeric input
 * degrades to the raw string with the symbol prefixed. */
export function formatMoney(
  amount: string | number | null | undefined,
  currency: string | null | undefined
): string | null {
  if (amount === null || amount === undefined || amount === '') {
    return null;
  }
  const symbol = currencySymbol(currency);
  const numeric = Number(amount);
  return `${symbol}${Number.isFinite(numeric) ? numeric.toLocaleString('en-GB') : amount}`;
}
